import React from "react";
import { Icon, Table } from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
    KEY_CONTACT_ACCOUNT,
    KEY_DATE,
    KEY_PHONE_NUMBER,
    KEY_USER,
    KEY_DURATION,
    KEY_ACTIONS,
    KEY_DIRECTION,
    KEY_SYSTEM_RESULT,
    KEY_NOTE,
    KEY_CALL_TAGS,
    KEY_DESTINATION,
    KEY_USER_RESULT,
} from "shared/constants/CALL_HISTORY_LOGS_COLUMNS";

const SortActions = ({ direction = false, onToggleSort = () => {} }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};

export const CallHistoryLogHeader = ({ isColumnHidden }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const dateOrder = Boolean(params.get("order") === "asc");

    const onDateFilterChange = () => {
        const query = new URLSearchParams(params);
        const order = !dateOrder ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(
            `${location.pathname}${query_string ? `?${query_string}` : ""}`
        );
    };

    return (
        <Table.Row>
            <SemanticTable.HeaderCell />
            {!isColumnHidden(KEY_DATE) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Date
                    <SortActions
                        direction={dateOrder}
                        onToggleSort={onDateFilterChange}
                    />
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CONTACT_ACCOUNT) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Contact/Account
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_PHONE_NUMBER) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Phone Number
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_USER) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    User
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_DIRECTION) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Direction
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_SYSTEM_RESULT) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    System Result
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_USER_RESULT) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    User Result
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_DURATION) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Duration
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_DESTINATION) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Destination
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CALL_TAGS) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Call Tags
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_NOTE) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Note
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACTIONS) && (
                <SemanticTable.HeaderCell className="CallHistoryTable__MediumFixedWidth">
                    Actions
                </SemanticTable.HeaderCell>
            )}
        </Table.Row>
    );
};
